import React, { useState, useEffect } from 'react';
import { VerisureTechnician } from '../../types';
import { TechnicianProfileModal } from '../../components/verisure/TechnicianProfileModal';
import { useNavigate } from 'react-router-dom';
import { useEnvironmentMode, isProductionMode } from '../../services/productionModeService';
import { db } from '../../services/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

const MOCK_TECHNICIANS: VerisureTechnician[] = [
  {
    id: 'tech_1',
    userId: 'tech_1',
    name: 'Engr. Babatunde Fashola',
    certificationLevel: 'Master Certified Field Specialist (Level 4)',
    specializations: ['Industrial Equipment', 'Commercial Gensets', 'High Voltage ACB', 'Heavy Machinery'],
    claimsAuditComplianceRating: 'Insurer-Approved Gold Tier',
    verifiedClaimsSupported: 28,
    jobsCompleted: 64,
    conditionScoreAvg: 94,
    rating: 4.95,
    reviewCount: 52,
    responseTime: '< 1 Hour',
    location: 'Ikeja Industrial Zone, Lagos',
    state: 'Lagos',
    bio: 'Lead Power Systems and Mechanical Engineer with 12+ years of field maintenance experience on Caterpillar, Perkins, and Cummins industrial gensets and electrical switchgear.',
    reviews: [
      { id: '1', ownerName: 'Chidi Okonkwo (Facility Director)', rating: 5, comment: 'Babatunde handled our 500kVA generator complete overhaul. Outstanding precision and full OEM parts.', date: '2026-08-15', itemTitle: 'CAT DE110E2 Genset' },
      { id: '2', ownerName: 'Dangote Agro Allied', rating: 5, comment: 'Prompt response time on emergency ACB breaker trip. Certified maintenance report was logged within minutes for our insurance filing.', date: '2026-07-28', itemTitle: 'Schneider ACB' },
    ],
    maintainedEquipments: [
      { itemId: 'ITM-4032', assetId: 'VRS-4032', make: 'Caterpillar', model: 'DE110E2 Genset', category: 'industrial', repairsCount: 5, conditionScore: 88, lastServicedDate: '2026-07-29' },
      { itemId: 'ITM-7718', assetId: 'VRS-7718', make: 'Schneider', model: 'MasterPact MTZ ACB', category: 'electrical', repairsCount: 3, conditionScore: 95, lastServicedDate: '2026-08-01' },
      { itemId: 'ITM-9912', assetId: 'VRS-9912', make: 'Perkins', model: '250kVA Silent', category: 'industrial', repairsCount: 6, conditionScore: 91, lastServicedDate: '2026-06-18' },
    ],
    createdAt: new Date(),
  },
  {
    id: 'tech_2',
    userId: 'tech_2',
    name: 'Amaka Eze-Nwachukwu',
    certificationLevel: 'Senior Optical & Electronics Engineer (Level 3)',
    specializations: ['Consumer Electronics', 'Telecom & Fiber', 'Optical Splicers', 'Medical Devices'],
    claimsAuditComplianceRating: 'Insurer-Approved Gold Tier',
    verifiedClaimsSupported: 19,
    jobsCompleted: 42,
    conditionScoreAvg: 92,
    rating: 4.9,
    reviewCount: 38,
    responseTime: '< 2 Hours',
    location: 'Victoria Island, Lagos',
    state: 'Lagos',
    bio: 'Certified telecommunications hardware specialist specializing in optical fiber fusion splicers, OTDR test benches, precision lab instrumentation, and high-end IT systems.',
    reviews: [
      { id: '1', ownerName: 'MainOne Infrastructure', rating: 5, comment: 'Calibrated our Fujikura 90S+ splicer unit perfectly. Splicing loss reduced to near zero dB.', date: '2026-08-02', itemTitle: 'Fujikura 90S+' },
      { id: '2', ownerName: 'Ifeanyi Okafor', rating: 4.8, comment: 'Very skilled technician. Replaced motherboard power IC with certified genuine components.', date: '2026-07-14', itemTitle: 'Dell Precision 7760' },
    ],
    maintainedEquipments: [
      { itemId: 'ITM-1029', assetId: 'VRS-1029', make: 'Fujikura', model: '90S+ Splicer', category: 'consumer_electronics', repairsCount: 3, conditionScore: 92, lastServicedDate: '2026-08-14' },
      { itemId: 'ITM-3301', assetId: 'VRS-3301', make: 'Anritsu', model: 'Site Master S331L', category: 'telecom', repairsCount: 2, conditionScore: 96, lastServicedDate: '2026-07-10' },
    ],
    createdAt: new Date(),
  },
  {
    id: 'tech_3',
    userId: 'tech_3',
    name: 'Ibrahim Danladi',
    certificationLevel: 'Master Automotive & Fleet Specialist (Level 4)',
    specializations: ['Vehicles & Fleets', 'Heavy Transport', 'Hydraulic Systems', 'Diagnostic ECM'],
    claimsAuditComplianceRating: 'Insurer-Approved Platinum Tier',
    verifiedClaimsSupported: 34,
    jobsCompleted: 55,
    conditionScoreAvg: 90,
    rating: 4.85,
    reviewCount: 44,
    responseTime: '< 3 Hours',
    location: 'Central Area, Abuja FCT',
    state: 'Abuja',
    bio: 'Automotive and hydraulic specialist covering commercial delivery fleets, utility vehicles, and heavy-duty transport diagnostics.',
    reviews: [
      { id: '1', ownerName: 'GIG Logistics Fleet', rating: 5, comment: 'Maintains our delivery vans on strict scheduled cycles. Zero downtime in the last 6 months.', date: '2026-08-10', itemTitle: 'Toyota Hilux 4x4' },
      { id: '2', ownerName: 'Alhaji Musa Kabir', rating: 4.7, comment: 'Excellent ECM diagnostic calibration on our Mercedes Actros truck.', date: '2026-06-30', itemTitle: 'Actros 3340' },
    ],
    maintainedEquipments: [
      { itemId: 'ITM-6620', assetId: 'VRS-6620', make: 'Toyota', model: 'Hilux 2.8 GD-6', category: 'vehicle', repairsCount: 4, conditionScore: 89, lastServicedDate: '2026-08-10' },
      { itemId: 'ITM-8819', assetId: 'VRS-8819', make: 'Mercedes-Benz', model: 'Actros 3340', category: 'vehicle', repairsCount: 7, conditionScore: 85, lastServicedDate: '2026-06-30' },
    ],
    createdAt: new Date(),
  },
  {
    id: 'tech_4',
    userId: 'tech_4',
    name: 'Samuel Chukwuemeka',
    certificationLevel: 'Certified HVAC & Thermal Specialist (Level 3)',
    specializations: ['Home Appliances', 'HVAC Chillers', 'Cold Chain Refrigeration', 'Inverters'],
    claimsAuditComplianceRating: 'Insurer-Approved Gold Tier',
    verifiedClaimsSupported: 15,
    jobsCompleted: 39,
    conditionScoreAvg: 93,
    rating: 4.88,
    reviewCount: 31,
    responseTime: '< 2 Hours',
    location: 'Trans Amadi, Port Harcourt',
    state: 'Rivers',
    bio: 'Commercial refrigeration and HVAC engineer with expertise in VRV/VRF multi-split systems, industrial chillers, and solar inverter backup banks.',
    reviews: [
      { id: '1', ownerName: 'Bonny Medical Clinic', rating: 5, comment: 'Crucial repair on our vaccine cold storage unit. Flawless diagnostics and test run.', date: '2026-08-12', itemTitle: 'Daikin VRV Chiller' },
    ],
    maintainedEquipments: [
      { itemId: 'ITM-5521', assetId: 'VRS-5521', make: 'Daikin', model: 'VRV-IV Air Handler', category: 'home_appliance', repairsCount: 4, conditionScore: 86, lastServicedDate: '2026-06-20' },
    ],
    createdAt: new Date(),
  },
];

export const TechniciansPage: React.FC = () => {
  const navigate = useNavigate();
  const { isProduction } = useEnvironmentMode();
  const [technicians, setTechnicians] = useState<VerisureTechnician[]>(() =>
    isProductionMode() ? [] : MOCK_TECHNICIANS
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState<string>('all');
  const [selectedLocation, setSelectedLocation] = useState<string>('all');
  const [minRating, setMinRating] = useState<number>(0);
  const [selectedTechnician, setSelectedTechnician] = useState<VerisureTechnician | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isProduction) {
      const fetchRealTechs = async () => {
        try {
          const q = query(collection(db, 'users'), where('role', '==', 'technician'));
          const snap = await getDocs(q);
          const realTechs: VerisureTechnician[] = snap.docs.map(doc => {
            const data = doc.data();
            return {
              id: doc.id,
              userId: doc.id,
              name: data.name || 'Verified Technician',
              certificationLevel: data.certificationLevel || 'Level 1 Certified Technician',
              specializations: data.specializations || ['General Hardware Maintenance'],
              claimsAuditComplianceRating: 'Insurer-Approved Verified Tier',
              verifiedClaimsSupported: data.verifiedClaimsSupported || 0,
              jobsCompleted: data.jobsCompleted || 0,
              conditionScoreAvg: data.conditionScoreAvg || 95,
              rating: data.rating || 5.0,
              reviewCount: data.reviewCount || 0,
              responseTime: '< 2 Hours',
              location: data.location || 'Lagos State',
              state: data.state || 'Lagos',
              bio: data.bio || 'Verified field engineer specializing in hardware maintenance and compliance audits.',
              reviews: [],
              maintainedEquipments: [],
              createdAt: new Date(),
            };
          });
          setTechnicians(realTechs);
        } catch {
          setTechnicians([]);
        }
      };
      fetchRealTechs();
    } else {
      setTechnicians(MOCK_TECHNICIANS);
    }
  }, [isProduction]);

  const specialties = [
    { key: 'all', label: 'All Specializations' },
    { key: 'Industrial Equipment', label: 'Industrial & Machinery' },
    { key: 'Consumer Electronics', label: 'Electronics & IT' },
    { key: 'Telecom & Fiber', label: 'Telecom & Fiber' },
    { key: 'Vehicles & Fleets', label: 'Vehicles & Fleet' },
    { key: 'Home Appliances', label: 'HVAC & Appliances' },
  ];

  const locations = [
    { key: 'all', label: 'All Locations' },
    { key: 'Lagos', label: 'Lagos State' },
    { key: 'Abuja', label: 'Abuja FCT' },
    { key: 'Rivers', label: 'Port Harcourt / Rivers' },
  ];

  const filteredTechs = technicians.filter((tech) => {
    const matchesSearch =
      tech.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tech.specializations.some((s) => s.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (tech.location || '').toLowerCase().includes(searchTerm.toLowerCase());

    const matchesSpecialty =
      selectedSpecialty === 'all' ||
      tech.specializations.some((s) => s.toLowerCase().includes(selectedSpecialty.toLowerCase()));

    const matchesLocation =
      selectedLocation === 'all' || tech.state === selectedLocation;

    const matchesRating = (tech.rating || 0) >= minRating;

    return matchesSearch && matchesSpecialty && matchesLocation && matchesRating;
  });

  const handleOpenProfile = (tech: VerisureTechnician) => {
    setSelectedTechnician(tech);
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-slate-950 font-sans p-3 sm:p-6 md:p-8 min-w-0 max-w-full overflow-hidden">
      <div className="max-w-7xl mx-auto space-y-6 sm:space-y-8 min-w-0 max-w-full">
        
        {/* Hero Banner */}
        <div className="bg-gradient-to-r from-slate-900 via-slate-900 to-slate-950 border border-slate-800 rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-10 shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl pointer-events-none"></div>

          <div className="relative z-10 max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-orange-500/10 border border-orange-500/30 text-orange-400 text-xs font-bold rounded-full mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
              <span>Verified Maintenance Network</span>
            </div>
            <h1 className="text-2xl sm:text-3xl md:text-5xl font-black text-white leading-tight">
              Find a <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-orange-400 to-amber-400">Certified Technician</span>
            </h1>
            <p className="text-slate-300 text-xs sm:text-sm md:text-base mt-2 leading-relaxed">
              Connect with vetted, KYC-verified field engineers. Every repair is logged immutably with photographic evidence and parts verification, making breakdown tracking and insurance claim filing fast and undisputed.
            </p>
          </div>
        </div>

        {/* Search & Filter Bar */}
        <div className="bg-slate-900 border border-slate-800 rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-xl space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            {/* Search Input */}
            <div className="md:col-span-2 relative">
              <input
                type="text"
                placeholder="Search by technician name, equipment type, skill..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full bg-slate-950 border border-slate-700 text-white rounded-2xl pl-10 pr-4 py-3 text-sm focus:outline-none focus:border-orange-500"
              />
              <span className="absolute left-3.5 top-3.5 text-slate-500 text-sm">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </span>
            </div>

            {/* Specialty Filter */}
            <div>
              <select
                value={selectedSpecialty}
                onChange={(e) => setSelectedSpecialty(e.target.value)}
                className="w-full bg-slate-950 border border-slate-700 text-white rounded-2xl px-4 py-3 text-sm focus:outline-none focus:border-orange-500"
              >
                {specialties.map((spec) => (
                  <option key={spec.key} value={spec.key} className="bg-slate-900 text-white">
                    {spec.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Location Filter */}
            <div>
              <select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                className="w-full bg-slate-950 border border-slate-700 text-white rounded-2xl px-4 py-3 text-sm focus:outline-none focus:border-orange-500"
              >
                {locations.map((loc) => (
                  <option key={loc.key} value={loc.key} className="bg-slate-900 text-white">
                    {loc.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Quick Filter Tags & Rating Filter */}
          <div className="flex flex-wrap items-center justify-between gap-3 pt-3 border-t border-slate-800 text-xs">
            <div className="flex items-center gap-2">
              <span className="text-slate-400 font-bold uppercase tracking-wider text-[10px]">Min Rating:</span>
              {[0, 4.5, 4.8].map((rating) => (
                <button
                  key={rating}
                  type="button"
                  onClick={() => setMinRating(rating)}
                  className={`px-3 py-1 rounded-full font-bold transition ${
                    minRating === rating
                      ? 'bg-gradient-to-r from-red-600 via-orange-500 to-amber-500 text-white shadow-md'
                      : 'bg-slate-800 text-slate-400 hover:text-white'
                  }`}
                >
                  {rating === 0 ? 'All' : `${rating}+ ★`}
                </button>
              ))}
            </div>

            <div className="text-slate-400">
              Showing <strong className="text-white">{filteredTechs.length}</strong> verified technicians
            </div>
          </div>
        </div>

        {/* Technician Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredTechs.map((tech) => (
            <div
              key={tech.id}
              className="bg-slate-900 border border-slate-800 rounded-3xl p-6 flex flex-col justify-between hover:border-orange-500/40 transition group shadow-xl"
            >
              <div>
                {/* Header Profile */}
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-tr from-red-600 via-orange-500 to-amber-500 p-0.5 shadow-md shadow-orange-500/20 shrink-0">
                      <div className="w-full h-full bg-slate-950 rounded-2xl flex items-center justify-center text-xl font-black text-white">
                        {tech.name.charAt(0)}
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <h3 className="text-lg font-black text-white group-hover:text-orange-400 transition">
                          {tech.name}
                        </h3>
                        <span className="w-4 h-4 rounded-full bg-emerald-500/20 text-emerald-400 flex items-center justify-center text-[10px] font-bold" title="KYC Verified">✓</span>
                      </div>
                      <div className="text-xs text-slate-400 mt-0.5">{tech.certificationLevel}</div>
                      <div className="text-[11px] text-slate-500 flex items-center gap-1 mt-0.5">
                        <svg className="w-3 h-3 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        {tech.location}
                      </div>
                    </div>
                  </div>

                  <div className="text-right">
                    <div className="bg-amber-500/10 border border-amber-500/30 text-amber-400 px-2.5 py-1 rounded-xl text-xs font-black flex items-center gap-1">
                      <span>★</span> {tech.rating}
                    </div>
                    <div className="text-[10px] text-slate-500 mt-1">{tech.reviewCount} Reviews</div>
                  </div>
                </div>

                {/* Insurer Claims-Ready Evidence Badge */}
                <div className="bg-slate-950 border border-slate-800 rounded-2xl p-3 mb-4 flex items-center justify-between text-xs">
                  <div className="flex items-center gap-2.5">
                    <div className="w-7 h-7 rounded-lg bg-orange-500/10 border border-orange-500/20 text-orange-400 flex items-center justify-center">
                      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                        <polyline points="14 2 14 8 20 8"/>
                      </svg>
                    </div>
                    <div>
                      <div className="font-bold text-white text-[11px]">Insurer-Ready Maintenance Logs</div>
                      <div className="text-slate-400 text-[10px]">
                        Forensic breakdown logs & OEM part verification for insurance claims
                      </div>
                    </div>
                  </div>
                  <span className="text-emerald-400 font-bold text-[10px] bg-emerald-500/10 px-2 py-0.5 rounded uppercase">
                    Audit Ready
                  </span>
                </div>

                {/* Specializations Badges */}
                <div className="mb-4">
                  <div className="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">
                    Core Specializations
                  </div>
                  <div className="flex flex-wrap gap-1.5">
                    {tech.specializations.map((spec, i) => (
                      <span
                        key={i}
                        className="bg-slate-800/80 border border-slate-700 text-slate-300 text-[11px] px-2.5 py-1 rounded-lg"
                      >
                        {spec}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Maintained Equipments Sample */}
                <div className="bg-slate-950/60 border border-slate-800/80 rounded-2xl p-3 mb-5">
                  <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5 flex items-center justify-between">
                    <span>Equipments Maintained</span>
                    <span className="text-orange-400">{tech.maintainedEquipments?.length || 3} Machines</span>
                  </div>
                  <div className="space-y-1 text-xs text-slate-300">
                    {tech.maintainedEquipments?.slice(0, 2).map((eq, i) => (
                      <div key={i} className="flex justify-between items-center text-[11px]">
                        <span className="truncate">{eq.make} {eq.model}</span>
                        <span className="text-emerald-400 font-bold">{eq.conditionScore}/100</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="grid grid-cols-2 gap-3 pt-3 border-t border-slate-800">
                <button
                  type="button"
                  onClick={() => handleOpenProfile(tech)}
                  className="bg-slate-800 hover:bg-slate-700 text-slate-200 text-xs font-bold py-2.5 rounded-xl transition border border-slate-700"
                >
                  View Profile & Reviews
                </button>
                <button
                  type="button"
                  onClick={() => handleOpenProfile(tech)}
                  className="bg-gradient-to-r from-red-600 via-orange-500 to-amber-500 hover:opacity-95 text-white text-xs font-bold py-2.5 rounded-xl shadow-md shadow-orange-500/20 transition flex items-center justify-center gap-1.5"
                >
                  Book / Request &rarr;
                </button>
              </div>
            </div>
          ))}
        </div>

        {filteredTechs.length === 0 && (
          <div className="text-center py-16 text-slate-400 glass-card rounded-3xl border border-white/[0.08] border-dashed">
            <div className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mx-auto mb-3 text-slate-400">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <p className="text-sm font-semibold text-slate-300">
              {isProduction
                ? 'No certified technicians registered in this filter yet.'
                : 'No technicians match your current filter.'}
            </p>
            <p className="text-xs text-slate-500 mt-1">
              {isProduction
                ? 'Certified technicians can create an account and submit KYC credentials to appear in this directory.'
                : 'Try clearing your search term or selecting All Specializations.'}
            </p>
          </div>
        )}

        {/* Modal for full technician profile */}
        <TechnicianProfileModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          technician={selectedTechnician}
          onSelectEquipment={(targetId) => navigate(`/item/${targetId}`)}
        />
      </div>
    </div>
  );
};
